import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchCallerTimeZone = async (phoneNumber: string): Promise<string | null> => {
  try {
    const response = await queryExecute({
      query: graphql(`
        query CallerTimeZone($phoneNumber: String) {
          caller(phoneNumber: $phoneNumber) {
            id
            timeZone
          }
        }
      `),
      variables: { phoneNumber },
      fetchPolicy: 'no-cache',
    });

    return response.data.caller?.timeZone ?? null;
  } catch {
    return null;
  }
};
